module.exports = __webpack_public_path__ + "img/img60.ebbb1005.png";